import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { LockPagesLayout } from '@/routes/-lock-pages-layout'
import { getAccountCapabilities } from '@/features/ctrls-and-caps/get-account-capabilities'

export const Route = createFileRoute('/_app/account-locked')({
  component: RouteComponent,
  beforeLoad: async () => {
    const { canPlay } = await getAccountCapabilities()

    if (canPlay) {
      throw redirect({ to: '/' })
    }
  },
})

function RouteComponent() {
  return (
    <LockPagesLayout>
      <Outlet />
    </LockPagesLayout>
  )
}
